<template>
  <v-dialog
      v-model="internalDialog"
      width="360"
      @update:modelValue="handleDialogToggle"
  >
    <div class="v-common-dialog-wrapper custom-dialog alert">
      <strong class="modal-tit"></strong>
      <div class="v-common-dialog-content">
        <p class="modal-txt">{{ message }}</p>
        <v-text-field
            v-model="passwordValue"
            class="custom-input"
            style="margin-top:10px;"
            type="password"
            :placeholder="lang.placeholder('password')"
            :hide-details="true"
            @keyup.enter="confirmAction"
        ></v-text-field>
      </div>
      <div class="btn-wrap">
        <v-btn class="custom-btn btn-white" @click="cancelAction">
          {{ cancelText || lang.button('cancel') }}
        </v-btn>
        <v-btn class="custom-btn btn-blue" @click="confirmAction">
          {{ confirmText || lang.button('confirm') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useHandleCode } from "~/composables/useHandleCode";
import { usePasswordDialog } from '~/composables/usePasswordDialog';
import {useLanguage} from "~/composables/useLanguage";

const {lang} = useLanguage();

const passwordValue = ref('');
const { handlePasswordCheck } = usePasswordDialog();
const { handleErrorCode } = useHandleCode();

const props = defineProps({
  isOpen: Boolean,
  message: String,
  cancelText: String,
  confirmText: String,
});
const emit = defineEmits([
  'update:isOpen',
  'confirm',
  'cancel',
]);

const internalDialog = ref(props.isOpen);

watch(() => props.isOpen, val => {
  internalDialog.value = val;
});

const handleDialogToggle = (val: boolean) => {
  emit('update:isOpen', val);
};

const closeDialog = () => {
  emit('update:isOpen', false);
};

const confirmAction = async () => {
  // 비밀번호 체크 수행
  const ok = await handlePasswordCheck(passwordValue.value);
  if (ok) {
    emit('confirm');// 부모의 @confirm 이 여기에서 터집니다
    closeDialog();
  } else {
    // 체크 실패 → 에러 토스트 또는 인라인 표시
    // 예: this.$toast.error('비밀번호가 일치하지 않습니다.');
    handleErrorCode("E51005");
  }
};

const cancelAction = () => {
  emit('cancel');
  closeDialog();
};
</script>


<style scoped>
.modal-txt {
  word-break: keep-all;
}

.custom-btn {
  max-width: 88px;
}
</style>